<template>
  <div class="announcement-body">
    <div v-show="visible" class="announcement-box">
      <div class="head">
        <i class="close el-icon-error" @click="visible=false"></i>
        <div class="text">群信息</div>
        <div></div>
      </div>
      <div class="content">
        <div class="con-title">{{title}}</div>
        <div class="con-main">{{ content?content:"暂无内容" }}</div>
        <!-- <div>{{ content }}</div> -->
      </div>
    </div>
    <!--  遮罩层  -->
    <div class="mask" v-show="visible" @click="visible=false"></div>
    <slot :open="()=>{visible=true}"></slot>
  </div>
</template>

<script>

export default {
  name: "announcement",
  data() {
    return {
      content: this.text,
      visible: false
    }
  },
  props: {
    text: String,
    title: String
  },
  methods: {
    open() {
      this.visible = true
    }
  },
  watch: {
    text(val) {
      this.content = val
    },
  }
}
</script>

<style scoped lang="less">
.announcement-body {
  position: relative;

  .announcement-box {
    position: absolute;
    left: -400px;
    top: -100px;
    z-index: 99;
    width: 400px;
    height: 450px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.20);
    padding: 0 20px;

    .head {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // border-bottom: 1px solid #ececec;

      .close {
        color: rgb(184, 184, 184);
        font-size: 18px;
        cursor: pointer;
      }

      .text {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
      }
    }

    .content {
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: LEFT;
      color: #595e63;
      height: calc(100% - 60px);
      overflow: auto;
      word-break: break-all;
      .con-title{
        color: #000000;
        margin-bottom: 10px;
      }
    }
  }

  .mask {
    position: fixed;
    z-index: 98;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
